export enum AgentStatus {
  Active = "active",
  Inactive = "inactive",
  Suspended = "suspended",
  Deactivated = "deactivated",
}
